module.exports = {
    gtm_id: 'GTM-MHCKPZ7',
    stage: 'development',
    auth: ''
}